<template>
  <article :class="containerClass">
      <h2 v-if="this.title">{{ this.title }}</h2>

      <div class="collection-wrapper">
        <vue-article-list-item
          v-for="(item, index) in filteredItems()"
          :item="item"
          :key="item.nid"
          :readingTime="readingTime"
          :singleCard="isSingleCard(index)"
        ></vue-article-list-item>
      </div>

    <vue-infinite-pager
      v-cloak
      v-if="entityManager.storage.length"
      v-on:vuePagerCurrentPageUpdate="vuePagerCurrentPageUpdateCallback"
      :total-pages="totalPages"
    ></vue-infinite-pager>

    <div class="loader" v-if="this.loading">
      <div class="spin"></div>
      <div class="overlay"></div>
    </div>
  </article>
</template>

<script>
import { reactive, computed } from "vue";
import EntityManagerMixin from "./../mixins/EntityManager.vue";
import VueInfinitePager from "./VueInfinitePager.vue";
import VueArticleListItem from "./VueArticleListItem.vue";

export default {
  name: "VueArticleList",
  props: {
    "items-per-page": {
      default: 12,
    },
    "five-items-start-items-per-page": {
      default: 13,
    },
    lang: {
      default: "en",
    },
    title: {
      default: "",
    },
    readingTime: {
      default: "",
    },
    articleListType: {
      default: "",
    },
    articleDisplay: {
      default: "",
    },
    articleLimit: {
      default: 0,
    },
    articlesOrder: {
      default: 0,
    },
  },
  mixins: [EntityManagerMixin],
  components: { VueInfinitePager, VueArticleListItem },
  data() {
    return {
      loading: false,
      message: this.$parent.message,
      st: [],
      stf: [],
      str: [],
    };
  },

  computed: {
    containerClass() {
      const value = this.articleDisplay === "hero_and_small"
        ? "articles-featured"
        : this.articleDisplay === "single_card"
        ? "articles-block single-card"
        : "articles-list";
      return `articles ${value}`;
    },
    currentPage() {
      return this.params.page != undefined ? this.params.page : 0;
    },
    totalPages() {
      let total = 1;
      if (this.entityManager.count > 0) {
        if (this.articleDisplay == "hero_and_small") {
          // First page consists of 13 items, the rest should be 12
          total =
            Math.ceil(
              (this.entityManager.count - this.fiveItemsStartItemsPerPage) /
                this.itemsPerPage
            ) + 1;
          if (total < 1) {
            total = 1;
          }
        } else {
          total = Math.ceil(this.entityManager.count / this.itemsPerPage);
        }
      }
      return total;
    },
    totalItemsCount() {
      return this.entityManager.count ? this.entityManager.count : 0;
    },
    currentCount() {
      return this.entityManager.storage.length
        ? this.entityManager.storage.length
        : 0;
    },
    requestParams() {
      return Object.assign(this.params, {
        _format: "json",
      });
    },
  },
  watch: {},
  methods: {
    isSingleCard(i) {
      if (this.articleDisplay === "hero_and_small") {
        return i === 0 && true;
      } else {
        return this.articleDisplay === "single_card" && true;
      }
    },
    filteredItems() {
      this.st = this.entityManager.storage;
      let k = JSON.parse(JSON.stringify(this.st));
      if (k !== undefined) {
        return k;
      }
    },
    filteredItemsFirst() {
      this.stf = this.entityManager.storage;
      let k = JSON.parse(JSON.stringify(this.stf));
      if (k !== undefined) {
        return k[0];
      }
    },
    filteredItemsRest() {
      this.str = this.entityManager.storage;
      let k = JSON.parse(JSON.stringify(this.str));
      if (Array.isArray(k) === true) {
        let filtered = k.slice(0, 5);
        filtered.shift();
        return filtered;
      }
    },

    getQueryParam(p) {
      return new URLSearchParams(window.location.search).get(p);
    },
    getQueryParams() {
      let entries = new URLSearchParams(window.location.search).entries(),
        p = [];
      for (let pair of entries) {
        if (pair[0].match(/(f+\[+[0-9]+\])+/g)) {
          p[pair[0]] = pair[1];
        }
      }
      return p;
    },
    resetStorage() {
      this.entityManager.storage = {};
      // If storage is reset, reset pager as well.
      this.params.page = 0;
    },
    setQueryParams() {
      let itemsPerPageTemp = this.itemsPerPage;
      let offset = 0;
      if (this.articleDisplay == "hero_and_small") {
        offset = 1;
        if (this.params.page == 0 || this.params.page == undefined) {
          itemsPerPageTemp = this.fiveItemsStartItemsPerPage;
          offset = 0;
        }
      }

      this.params = {
        page: this.currentPage,
        items_per_page: itemsPerPageTemp,
        offset: offset,
      };
    },
    loadArticles(resetStorage, showLoading) {
      if (showLoading) {
        this.loading = true;
      }

      this.setQueryParams();

      var _this = this;

      this.loadEntities(this.requestParams, false, resetStorage)
        .then(() => {
          _this.preloaded = false;
          _this.loading = false;
          _this.loaded = true;

          // console.log(
          //   "_this.entityManager.storage -1",
          //   _this.entityManager.storage
          // );
          this.st = _this.entityManager.storage;
          this.stf = _this.entityManager.storage;
          this.str = _this.entityManager.storage;
          // console.log("this.articleListType", this.articleListType);
          if (
            _this.articleListType === "newest_articles" &&
            _this.articleLimit > 0
          ) {
            if (_this.entityManager.storage.length > _this.articleLimit) {
              _this.entityManager.storage = _this.entityManager.storage.slice(
                0,
                _this.articleLimit
              );
            }
            if (_this.entityManager.count > _this.articleLimit) {
              _this.entityManager.count = _this.articleLimit;
            }
          }
          // console.log("this.articlesOrder", this.articlesOrder);
          if (_this.articleListType === "selected_articles") {
            if (this.articlesOrder != "null" && this.articlesOrder != null) {
              let articleNids = JSON.parse(this.articlesOrder);
              let newStorage = [];

              for (let order of articleNids) {
                for (let article of _this.entityManager.storage) {
                  if (order === article.nid) {
                    newStorage.push(article);
                  }
                }
              }

              if (newStorage.length !== 0) {
                _this.entityManager.storage = newStorage;
              }
            }
          }
        })
        .catch((e) => {
          // @todo implement error handling.
          console.log("An error occured performing the request.");
          console.log(e);
          _this.loading = false;
        });
    },
    vuePagerCurrentPageUpdateCallback(payload) {
      this.params.page = payload;
      this.loadArticles(false, true);
    },
  },
  created() {},
  mounted() {
    this.loadArticles(false, false);
  },
};
</script>
